<template>
<!--    <div class="task_box" :data-id="task._id" :data-date="(Date.now() - task.date)" :data-name="(task.name.charCodeAt(0) * 10000 + task.name.charCodeAt(1) * 100 + task.name.charCodeAt(2))" :data-priority="priority_text" style="color: ${task.date}" v-if="done_show">-->
    <div 
        :class="task.anime ? 'task_box ' + task.anime : 'task_box'" 
        :data-id="task._id" 
        v-if="done_show" 
        :data-name="(task.name)" 
        :data-section="(task.section)" 
        draggable="true" 
        @dragstart="onDragStart(task._id, task.project_id, task.section)"
    >
        <div 
            class="tasks_row_body" 
            v-if="search || !task.parent" 
            @contextmenu.prevent="ContextMenu" 
            @click="tabTask(task._id)"
        >
            <div :class="show_subtask ? 'task__open show' : 'task__open'" v-if="subtasks.length > 0 && !search" @click="openSubTask">
                <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.576117 0.99729C0.70958 0.997029 0.838921 1.04351 0.941688 1.12867L4.00335 3.68766L7.07071 1.22006C7.12914 1.17261 7.19637 1.13718 7.26854 1.1158C7.3407 1.09442 7.41638 1.08751 7.49122 1.09547C7.56607 1.10343 7.6386 1.12611 7.70465 1.16219C7.77071 1.19828 7.82898 1.24706 7.87611 1.30574C7.92356 1.36417 7.95899 1.4314 7.98037 1.50356C8.00176 1.57573 8.00866 1.65141 8.0007 1.72625C7.99274 1.8011 7.97006 1.87363 7.93398 1.93968C7.89789 2.00573 7.84911 2.064 7.79043 2.11114L4.3632 4.87006C4.261 4.95407 4.13279 5 4.00049 5C3.86818 5 3.73998 4.95407 3.63777 4.87006L0.210546 2.01403C0.152707 1.96608 0.104896 1.90719 0.0698514 1.84073C0.0348067 1.77427 0.0132165 1.70156 0.00631857 1.62674C-0.00057888 1.55193 0.0073514 1.47649 0.0296535 1.40474C0.0519562 1.333 0.0881925 1.26635 0.136289 1.20864C0.189442 1.14311 0.256451 1.09017 0.332499 1.05363C0.408547 1.01709 0.491746 0.997848 0.576117 0.99729Z" fill="#9A9A9A"/>
                </svg>
            </div>
            <router-link
                :to="linkToTask(task._id)"
                class="tasks_row"
                :class="checkSubTask_in_Task(task._id) ? 'radius-none ' + task_class : task_class"
                :id="`task_${task._id}`"
                @click="openTask"
            >
                <h4 v-if="!isEdit" class="task_title" :id="task.local_id" :class="{'ml-0': $route.params.chat_id}">
                    {{ task.name }}
                </h4>

                <input 
                    v-else
                    class="task_title task_title-edit"
                    ref="renameTaskInputNode"
                    v-model="editingText" 
                    type="text"
                    :class="{'ml-0': $route.params.chat_id}"
                    @blur="handleSave" 
                    @click.prevent.stop="() => {}" 
                    @keyup.exact.enter="handleSave" 
                    @focus.prevent.stop="() => {}"
                >

                <div style="display: flex;height: 100%;">
                    <div class="task__subtask" @click.prevent="addSubTask(task._id)">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.49897 5.08594H4.91564V0.502604C4.91564 0.392097 4.87174 0.286117 4.7936 0.207976C4.71546 0.129836 4.60948 0.0859375 4.49897 0.0859375C4.38846 0.0859375 4.28248 0.129836 4.20434 0.207976C4.1262 0.286117 4.0823 0.392097 4.0823 0.502604V5.08594H-0.501029C-0.611536 5.08594 -0.717517 5.12984 -0.795657 5.20798C-0.873797 5.28612 -0.917696 5.3921 -0.917696 5.5026C-0.919752 5.55676 -0.910176 5.61072 -0.889614 5.66086C-0.869053 5.711 -0.837982 5.75615 -0.798497 5.79326C-0.759012 5.83038 -0.71203 5.8586 -0.660716 5.87602C-0.609403 5.89345 -0.554951 5.89967 -0.501029 5.89427H4.0823V10.5026C4.0823 10.6131 4.1262 10.7191 4.20434 10.7972C4.28248 10.8754 4.38846 10.9193 4.49897 10.9193C4.60948 10.9193 4.71546 10.8754 4.7936 10.7972C4.87174 10.7191 4.91564 10.6131 4.91564 10.5026V5.91927H9.49897C9.60948 5.91927 9.71546 5.87537 9.7936 5.79723C9.87174 5.71909 9.91564 5.61311 9.91564 5.5026C9.91564 5.3921 9.87174 5.28612 9.7936 5.20798C9.71546 5.12984 9.60948 5.08594 9.49897 5.08594Z" fill="#000"/>
                        </svg>
                        <p>{{ $t('task.subtask') }}</p>
                    </div>

                    <div class="task__priority">
                        <div class="task__priority__title" 
                            @click.prevent="openPriorityMenu"
                            :style="`background-color: ${priority_color == 'transparent' ? '#f3f3f3' : priority_color}; color: ${priority_color == 'transparent' ? '#898989' : priority_color == '#F4F915' || priority_color == '#f3f3f3' ? '#000' : '#fff'}`"
                        >
                            <p>{{enumPriority[priority_text]}}</p>
                            <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.57221 0.99729C0.705674 0.997029 0.835015 1.04351 0.937781 1.12867L3.99944 3.68766L7.06681 1.22006C7.12523 1.17261 7.19246 1.13718 7.26463 1.1158C7.33679 1.09442 7.41247 1.08751 7.48732 1.09547C7.56216 1.10343 7.6347 1.12611 7.70075 1.16219C7.7668 1.19828 7.82507 1.24706 7.87221 1.30574C7.91965 1.36417 7.95509 1.4314 7.97647 1.50356C7.99785 1.57573 8.00476 1.65141 7.99679 1.72625C7.98883 1.8011 7.96616 1.87363 7.93007 1.93968C7.89399 2.00573 7.8452 2.064 7.78653 2.11114L4.3593 4.87006C4.25709 4.95407 4.12889 5 3.99658 5C3.86428 5 3.73607 4.95407 3.63387 4.87006L0.20664 2.01403C0.1488 1.96608 0.10099 1.90719 0.0659451 1.84073C0.0309005 1.77427 0.00931025 1.70156 0.00241232 1.62674C-0.00448513 1.55193 0.00344515 1.47649 0.0257473 1.40474C0.0480499 1.333 0.0842862 1.26635 0.132383 1.20864C0.185535 1.14311 0.252544 1.09017 0.328592 1.05363C0.404641 1.01709 0.48784 0.997848 0.57221 0.99729Z" :fill="priority_color == 'transparent' ? '#898989' : priority_color == '#F4F915' || priority_color == '#f3f3f3' ? '#000' : '#fff'"/>
                            </svg>
                        </div>
                        <div class="task__priority__lists" v-if="show_menu">
                            <div class="task__priority__list" style="background-color: #f3f3f3; color: #000" v-if="priority_text != 'Normal'" @click.prevent="priorityChange('#f3f3f3', 'Normal')">
                                {{ this.$t('task.priority.normal') }}
                            </div>
                            <div class="task__priority__list" style="background-color: #F4F915; color: #000000" v-if="priority_text != 'Medium'" @click.prevent="priorityChange('#F4F915', 'Medium')">
                                {{ this.$t('task.priority.medium') }}
                            </div>
                            <div class="task__priority__list" style="background-color: #F12E2E" v-if="priority_text != 'High'" @click.prevent="priorityChange('#F12E2E', 'High')">
                                {{ this.$t('task.priority.high') }}
                            </div>
                        </div>
                    </div>

                    <!-- <div class="task_options" ref="task_setting">
                        <div>
                            <i class="el-icon-delete task_delete_icon" @click.prevent="deleteTask(task)"></i>
                        </div>
                    </div> -->

                    <img :src="require(`@/assets/static/images/recur.svg`)" class="task__recur" v-if="get_recur.find(e => e.task_id == task._id)"/>
             
                    <div class="task__date" v-if="task.assign && task.assign.date">
                        <span v-html="assignDateTask(task.assign.date)"></span>
                    </div>

                    <div class="mtb-auto unread-container" v-if="get_unreaded_messages_in_tasks[task._id] > 0" :class="{'flex-must': task_class == 'tasks_row_completed'}">
                        <p 
                            v-if="getListsMentions[$route.params.project_id] && getListsMentions[$route.params.project_id][task._id] && getListsMentions[$route.params.project_id][task._id].mentions > 0"
                            class="unread-container__mention"
                        >
                            @
                        </p>
                        <p v-if="get_unreaded_messages_in_tasks[task._id] > 0"
                           class="unread_messages unread-container__count">
                            {{ unread_msg[task._id] }}
                        </p>
                    </div>
                    
                    <div v-if="task.assign && task.assign.user_id || check_assign">
                        <div class="task__priority__assign_to">
                            <span :style="{border: '1px solid ' + assign_name.color, color: assign_name.color}" v-if="assign_name" v-html="$w_user_image(assign_name, 70, true, 'task')"></span>
                            <span :style="{border: '1px solid ' + userName_Assign(task.assign.user_id).color, color: userName_Assign(task.assign.user_id).color}" v-else v-html="task.assign.user_id ? $w_user_image(userName_Assign(task.assign.user_id), 70, true, 'task') : ''"></span>
                            <!-- {{userName_Assign(task.assign.user_id).color}} -->
                            <!-- <span :style="{border: '1px solid ' + assign_name.color, color: assign_name.color}" v-if="assign_name" v-html="$w_user_image(assign_name, 70, false, 'task')"></span>
                            <span :style="{border: '1px solid ' + userName_Assign(task.assign.user_id).color, color: userName_Assign(task.assign.user_id).color}" v-else>{{userName_Assign(task.assign.user_id).name ? userName_Assign(task.assign.user_id).name[0] : ''}}</span> -->
                            <!-- <span v-if="assign_name.name" :style="{backgroundColor: assign_name.color, color: 'white'}">{{assign_name.name[0]}}</span> -->
                        </div>
                    </div>

                    <!-- <div v-if="priority_text != 'Normal'"> -->
                        <div class="task__priority-line" :style="`background-color: ${priority_color};${priority_text != 'Normal' ? 'opacity: 1;' : 'opacity: 0;'}`"></div>
                    <!-- </div> -->

                </div>

            </router-link>
            <el-checkbox v-model="task.done" @input="change_complete"></el-checkbox>
        </div>

        <!-- <div v-if="show_subtask"> -->
        <transition :name="transition_name" v-if="!search">
        <!-- <transition type="transition" name="list-complete"> -->
            <div v-if="show_subtask" style="transition: all 0.3s;">
                <draggable v-if="subtasks.length > 0" v-model="subtasks" v-bind="dragOptions" :group="task._id" class="draggable_tasks subtask" @change="onEndTaskDrop">
                    <transition-group type="transition" class="transition-group__subtask" style="padding-bottom: 2px;">
                        <div v-for="subtask of subtasks" :key="subtask._id" style="margin-top: 4px;">
                            <SubTask :key="subtask._id + 1" :subtask="subtask" :project_id="project_id" :parent="task._id" @change_complete_sub="change_complete_sub" :chat_id="chat_id"/>
                        </div>
                    </transition-group>
                </draggable>
            </div>
        </transition>

        <!-- </div> -->

    </div>
</template>

<script>

    import { mapActions, mapGetters, mapMutations } from "vuex"
    import RenameElement from "@/components/app/RenameElement"
    import SubTask from './SubTask.vue'
    import {EventEmitter} from '../../main'
    import File from '../../utils/aws'
    import draggable from "vuedraggable"
    import moment from "moment"

    export default {
        name: "Task",
        props: {
            task: {
                type: Object,
                required: true
            },
            search: [Boolean],
            chat_id: [String]
        },
        data() {
            return {
                transition_name: '',
                done: false,
                task_class: "",
                show_menu: false,
                priority_color: 'transparent',
                priority_text: 'Normal',
                assign_name: '',
                subtasks: [],
                subtasks_done: [],
                this_user_change_order: true,
                this_user_change_done: true,
                show_subtask: true,
                assign_date: '',
                check_assign: '',
                done_show: true,
                project_id: '',
                default_expand_subtask: '',
                isEdit: false,
                editingText: '',
                unread_msg: [],
                enumAssign: {
                    Today: this.$t('task.assign.today'),
                    Yesterday: this.$t('task.assign.yesterday'),
                    Tomorrow: this.$t('task.assign.tomorrow')
                },
                enumPriority: {
                    Normal: this.$t('task.priority.normal'),
                    Medium: this.$t('task.priority.medium'),
                    High: this.$t('task.priority.high')
                }
            }
        },
        async mounted() {

            // if (localStorage.getItem('register_new_user_date')) {
            //     setTimeout(() => {
            //         const removeEmoji = this.task.name.replace(/^[\p{Emoji_Presentation}\p{Extended_Pictographic}]+\s*/u, '');
            //         const keyArray = [
            //             "first_task_name.delete_section_tip",
            //             "first_task_name.share_list_tip",
            //             "first_task_name.group_chat_description",
            //             "first_task_name.organize_tasks_tip",
            //             "first_task_name.organize_tasks_tip",
            //             "first_task_name.start_group_chat_tip",
            //             "first_task_name.add_tasks_tip",
            //             "first_task_name.create_list_tip",
            //             "first_task_name.inbox_description"
            //         ]
            //         const taskNames = [
            //             "Ready to start? You can delete any section and its tasks by clicking the '×' next to the section title.",
            //             "Share any List into a Group Chat to collaborate with your team.",
            //             "Use Group Chats for team discussions. (Tasks have their own chats too, but Group Chats are for broader conversations with a List view next to them.)",
            //             "️ Organize tasks into Lists to keep everything structured.",
            //             "Organize tasks into Lists to keep everything structured.",
            //             "Start a new Group Chat with the '+' button at the bottom left.",
            //             "After creating a List, start adding tasks one by one.",
            //             "Create a new List by clicking the '+' button at the bottom left.",
            //             "Inbox is your personal space for private tasks, quick notes, or anything you prefer not to share. (For team collaboration, use Lists and Group Chats.)"
            //         ]
            //         taskNames.forEach((name, index) => {
            //             if (removeEmoji == name) {
            //                 this.socket_rename_task({
            //                     name: this.$t(keyArray[index]),
            //                     task_id: this.task._id,
            //                     project_id: this.project_id
            //                 })
            //             }
            //         })
            //     }, 500)
            //     setTimeout(() => {
            //         localStorage.removeItem('register_new_user_date')
            //     }, 2000)
            // }

            this.editingText = this.task.name
            this.recur = this.get_recur.find(e => e.task_id == this.task._id)
            // if (!this.$route.params.task_id) {
                setTimeout(() => {
                    this.transition_name = 'slide-fade'
                }, 1000)
            // }

            EventEmitter.$on('RenameTaskFromContext', taskId => {
                if (taskId == this.task._id) {
                    this.isEdit = true
                    setTimeout(() => {
                        this.$refs.renameTaskInputNode.focus()
                    }, 0)
                }
            })

            EventEmitter.$on('openSubtask', (subtask_id) => {
                if (this.subtasks.length) {
                    this.subtasks.forEach((e) => {
                        if (e._id == subtask_id) {
                            if (!this.show_subtask) {
                                this.openSubTask()
                            }
                        }
                    })
                }
            })

            EventEmitter.$on('clearSubTask', (data) => {
                this.subtasks.forEach((e, i) => {
                    if (e._id == data._id) {
                        this.subtasks.splice(i, 1)
                        // setTimeout(() => {
                        //     // let size = document.querySelector(`[data-id="${this.task._id}"] .draggable_tasks.subtask .transition-group__subtask`).offsetHeight
                        //     let w = this.subtasks.length * 38 - 1
                        //     document.querySelector(`[data-id="${this.task._id}"] .draggable_tasks.subtask`).style.height = w + 'px'
                        // }, 100)
                    }
                })
            })

            this.project_id = this.task.project_id

            setTimeout(() => {

                this.unread_msg = this.get_unreaded_messages_in_tasks

                if (document.querySelector('.avatar_img')) {
                    document.querySelectorAll('.avatar_img').forEach((e) => {
                        e.parentNode.classList.add("avatar_img_span")
                    })
                }

                this.priority_text = this.task.priority ? this.task.priority : 'Normal'

                if (this.priority_text == 'Normal') {
                    this.priority_color = '#f3f3f3'
                } else if (this.priority_text == 'Medium') {
                    this.priority_color = '#F4F915'
                } else if (this.priority_text == 'High') {
                    this.priority_color = '#F12E2E'
                }

                this.done = this.task.done

                if (this.getSubTask) {
                    if (this.subtasks.length == 0) {

                        let sub = []

                        this.getSubTask.forEach((e, i) => {
                            if (e.parent == this.task._id) {
                                sub.push(e)
                            }
                        })

                        let filtered = sub.filter(function (el) {
                            return el != null
                        })

                        let res = filtered.reduce((o, i) => {
                            if (i._id) {
                                if (!o.find(v => v._id == i._id)) {
                                    o.push(i)
                                }
                            } else {
                                o.push(i)
                            }
                            return o
                        }, [])

                        this.subtasks = res
                        this.subtasks.sort( function (a, b) {
                            return a.order - b.order
                        })

                    }
                }

                if (this.subtasks.length > 0) {
                    this.subtasks.forEach((task) => {
                        if (this.get_unreaded_messages_in_tasks[task._id] > 0) {
                            this.show_subtask = true
                            localStorage.setItem(task._id, this.show_subtask)
                        }
                    })
                }

                
                if (this.getUserData.expand_subtask == true) {
                    this.show_subtask = true
                    this.default_expand_subtask = 'Enabled'
                }

                if (this.getUserData.expand_subtask == false) {
                    this.show_subtask = false
                    this.default_expand_subtask = 'Disabled'
                }

                this.show_subtask = localStorage.getItem(this.task._id) == 'true' ? true : false

            }, 50)

            this.task_class = this.task.done ? "tasks_row_completed" : "";
            EventEmitter.$on('Priority', (data) => {
                if (data.task_id == this.task._id) {
                    this.priority_text = data.priority
                    if (this.priority_text == 'Normal') {
                        this.priority_color = '#f3f3f3'
                    } else if (this.priority_text == 'Medium') {
                        this.priority_color = '#F4F915'
                    } else if (this.priority_text == 'High') {
                        this.priority_color = '#F12E2E'
                    }
                }
            })

            EventEmitter.$on('AssignDate', (data) => {
                if (data.date) {
                    if (data.task_id == this.task._id) {
                        this.assign_date = data.date
                    }
                } else {
                    this.assign_date = ''
                }
                
            })

            EventEmitter.$on('changeOrder', (data) => {
                if (data) {

                    if (this.this_user_change_order) {
                        let arr = []
                        // this.subtasks = []
                        data.new_order.forEach((a, i) => {
                            this.subtasks.forEach((e) => {
                                if (e.parent == this.task._id) {
                                    if (e._id == a.task_id) {
                                        arr[a.order] = e
                                    } else {
                                        arr[e.order] = e
                                    }
                                }
                            })
                        })
                        let filtered = arr.filter(function (el) {
                            return el != null;
                        });
                        this.subtasks = []
                        this.subtasks = filtered
                    }else{
                        this.this_user_change_order = true
                    }
                }
            })

            let off = true
            EventEmitter.$on('offAddSubTask', (data) => {
                off = data
                // this.checkSubTask_in_Task(this.task._id)
            })

            EventEmitter.$on('addSubTask', (data) => {
                if (off) {
                    if (data.parent == this.task._id) {
                        this.subtasks.push(data)
                    }
                }
            })

            EventEmitter.$on('AssignUser', (data) => {
                // console.log(0)
                if (data.user_id) {
                    // console.log(1)
                    if (data.task_id == this.task._id) {
                        if (this.getUserData._id == data.user_id) {
                            this.assign_name = this.getUserData
                        } else {
                            // console.log(2)
                            this.getKnownUsers.forEach((e) => {
                                if (e._id == data.user_id) {
                                    // console.log(3)
                                    this.assign_name = e
                                }
                            })
                        }
                        this.check_assign = true
                    }
                } else {
                    if (data.task_id == this.task._id) {
                        this.task.assign.user_id = false
                    }
                    this.assign_name = "";
                    this.check_assign = false
                }
            })

            EventEmitter.$on('change_completes', (data) => {
                if (data.task_id == this.task._id) {
                    this.done_show = !this.done_show
                    // this.show_subtask = data.show
                    // localStorage.setItem(this.task._id, data.show)
                }
            })

            EventEmitter.$on('SubTaskDone', (data) => {
                if (this.this_user_change_done) {
                    let task_id = data.task_id
                    this.subtasks.forEach((e, i) => {
                        if (e._id == task_id) {
                            this.subtasks[i].done = data.done
                            // this.subtasks = this.subtasks
                        }
                    })
                    // let task_id = data.task_id
                    // let done = this.subtasks_done.filter((e) => e._id == task_id)
                    // let undone = this.subtasks.filter((e) => e._id == task_id)

                    // if (done.length > 0) {
                    //     this.subtasks_done.forEach((e, i) => {
                    //         if (e._id == task_id) {
                    //             this.subtasks_done.splice(i, 1)
                    //             // this.subtasks.push(e)
                    //             let task = this.subtasks
                    //             task.push(e)
                    //             this.subtasks = task
                    //         }
                    //     })
                    // }

                    // if (undone.length > 0) {
                    //     this.subtasks.forEach((e, i) => {
                    //         if (e._id == task_id) {
                    //             this.subtasks.splice(i, 1)
                    //             // this.subtasks_done.unshift(e)
                    //             let task = this.subtasks_done
                    //             task.unshift(e)
                    //             this.subtasks_done = task
                    //         }
                    //     })
                    // }
                }else{
                    this.this_user_change_done = true
                }
            })

            EventEmitter.$on('removeTask', (data) => {
                if (data == this.task._id) {
                    document.querySelector(`.task_box[data-id="${this.task._id}"]`).classList.add('removeTask')
                    setTimeout(() => {
                        this.deleteTask(this.task)
                    }, 500)
                }
            })

            // EventEmitter.$on('checkShowSubTask', () => {
            //     this.show_subtask = localStorage.getItem(this.task._id) == 'false' ? false : true
            // })

        },
        methods: {
            ...mapActions([
                "socket_completed_task",
                "socket_delete_task",
                "socket_rename_task",
                "socket_change_order",
                "open_subtask"
            ]),
            ...mapMutations([
                "setUserFileSize_minus",
                "setMessage",
                "change_enabled_recur"
            ]),
            momentFunc(date) {
                const m = moment(Number(date));
                const nowYear = moment().year();
                if (m.year() === nowYear) {
                    return m.format('MMM DD');
                } else {
                    return m.format('MMM DD, YYYY');
                }
            },
            openTask() {
                // setTimeout(() => {
                //     console.log('iiiiiiiiiiiiii')
                //     EventEmitter.$emit('openTask')
                // }, 500)
            },
            handleSave() {
                this.isEdit = false
                this.socket_rename_task({
                    name: this.editingText.trim() != "" ? this.editingText.trim() : "Untitled",
                    task_id: this.task._id,
                    project_id: this.project_id
                })
            },
            ContextMenu(e) {
                // e.stopPropagation()
                let position_menu = {
                    x: e.x,
                    y: e.y,
                    task_id: this.task._id,
                    list_id: this.task.project_id,
                    task: this.task
                }

                setTimeout(() => {
                    EventEmitter.$emit('ContextMenu_open', position_menu)
                }, 10)

            },
            onDragStart(task_id, project_id, section_id) {
                let data = {
                    task_id: task_id,
                    project_id: project_id,
                    section_id: section_id
                }
                EventEmitter.$emit('TaskMove', data)
            },
            checkSubTask_in_Task (task_id) {
                let tasks = this.subtasks
                let bool = false
                tasks.forEach((e) => {
                    if (e.parent == task_id) {
                        bool = true
                    }
                })
                return bool
            },
            checkAssignTo (assign_name, user_id) {
                // let tasks = this.getTasks[this.project_id]
                // tasks.forEach((task) => {
                //     if (task._id == task_id) {
                //         if (task.assign.user_id) {
                //             return true
                //         }
                //     }
                // })
                // console.log(assign_name, user_id)
                // if (task_id == this.task._id) {
                    if (assign_name || user_id) {
                        return true
                    } else {
                        return false
                    }
                // }
            },
            checkSubTaskDone (task_id) {
                let tasks = this.subtasks
                let bool = false
                tasks.forEach((e) => {
                    if (e.parent == task_id) {
                        if (e.done) {
                            bool = true
                        }
                    }
                })
                return bool
            },
            openSubTask() {
                this.show_subtask = !this.show_subtask
                localStorage.setItem(this.task._id, this.show_subtask)
                EventEmitter.$emit('AnimeTask', true)
                //  this.open_subtask({
                //     task_id: this.task._id,
                //     project_id: this.task.project_id
                // })

            },
            // fill_tasks_array(getSubTask) {
            //     // this.subtask = []
            //     const tasks = getSubTask

            //     if (tasks) {
            //         tasks.forEach((e, i) => {
            //             if (e.parent == this.task._id) {
            //                 this.subtasks[e.order] = {}
            //                 if (this.subtasks[e.order]) {
            //                     this.subtasks[e.order] = e
            //                 }
            //             }
            //         })
            //     }
            // },
            change_complete_sub({ complete, task_id }) {

                this.subtasks.forEach((e, i) => {
                    if (e._id == task_id) {
                        this.subtasks[i].done = complete
                    }
                })

                this.socket_completed_task({
                    complete,
                    bool: false,
                    task_id: task_id,
                    project_id: this.$route.params.project_id,
                })

                this.this_user_change_done = false

                setTimeout(() => {

                    let tasks = this.subtasks
                    let new_order = []

                    tasks.forEach((e, i) => {
                        new_order.push({
                            task_id: e._id,
                            order: i
                        })
                    })

                    const new_order_position = {
                        out: true,
                        new_order: new_order,
                        project_id: this.project_id,
                    }

                }, 100)
            },
            onEndTaskDrop(evt) {

                EventEmitter.$emit('toggleOrderChanged')

                let tasks = this.subtasks
                let new_order = []

                tasks.forEach((e, i) => {
                    new_order.push({
                        task_id: e._id,
                        order: i
                    })
                })
                
                // EventEmitter.$emit('checkShowSubTask', true)
                // this.show_subtask = localStorage.getItem(this.task._id) == 'false' ? false : true

                const new_order_position = {
                    out: true,
                    new_order: new_order,
                    project_id: this.project_id,
                    evt: evt
                }
                this.this_user_change_order = false

                this.socket_change_order({ new_order_position, add_global: true })

            },
            addSubTask (task_id) {
                this.show_subtask = true
                localStorage.setItem(this.task._id, this.show_subtask)
                EventEmitter.$emit('AnimeTask', true)
                let w_bool = false

                this.$w_plan(this, this.getPlan, 'subtask', () => {
                    this.setMessage({
                        key_message: "warning",
                        message: this.$planMessages.subtask.en,
                        plan: true
                    })
                    w_bool = true
                }, task_id)

                if (w_bool) {
                    return
                }

                const subtask = this.subtasks
                let stop = false
                subtask.forEach((e) => {
                    if (e.parent == task_id) {
                        if (e.name == '') {
                            stop = true
                        }
                    }
                })

                if (stop) {
                    return
                }

                this.show_subtask = true
                let order = []

                if (subtask.length > 0) {
                    subtask.forEach((e) => {
                        if (task_id == e.parent) {
                            order.push(e.order)
                        }
                    })
                } else {
                    order = 0
                }

                this.subtasks.push({
                    assign: {
                        user_id: ''
                    },
                    name: '',
                    project_id: this.$route.params.project_id,
                    order: order == 0 ? 1 : Math.max.apply(null, order) + 1,
                    parent: task_id,
                    _id: this.$w_decrypt(this.getUserData._id),
                })

                // setTimeout(() => {
                //     // let size = document.querySelector(`[data-id="${this.task._id}"] .draggable_tasks.subtask .transition-group__subtask`).offsetHeight
                //     let w = this.subtasks.length * 38 + 1
                //     document.querySelector(`[data-id="${this.task._id}"] .draggable_tasks.subtask`).style.height = w + 'px'

                //     document.querySelector(`[data-id="${this.task._id}"] .draggable_tasks.subtask`).classList.add('openSubtask')
                // }, 100)

                setTimeout(() => {
                    document.querySelector('.task__input-name input').focus()
                }, 500)

            },
            assignDate(date) {
                if (!date) return;

                if (!isNaN(date)) {
                    date = new Date(+date).toISOString();
                }

                const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime();
                const yesterday = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1).getTime();
                const tomorrow = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1).getTime();

                const dateFromComment = new Date(
                    new Date(date).getFullYear(),
                    new Date(date).getMonth(),
                    new Date(date).getDate()
                ).getTime();

                if (dateFromComment === today) return "Today";
                if (dateFromComment === yesterday) return "Yesterday";
                if (dateFromComment === tomorrow) return "Tomorrow";

                const currentLocale = this.$i18n.locale; // например 'ru', 'en', 'fr'
                const dateObj = new Date(date);

                if (new Date().getFullYear() === dateObj.getFullYear()) {
                    return new Intl.DateTimeFormat(currentLocale, {
                        day: "numeric",
                        month: "short"
                    }).format(dateObj);
                } else {
                    return new Intl.DateTimeFormat(currentLocale, {
                        day: "numeric",
                        month: "short",
                        year: "numeric"
                    }).format(dateObj);
                }
            },
            userName_Assign (user_id) {
                let name
                if (this.getUserData._id == user_id) {
                    name = this.getUserData
                } else {
                    // console.log(this.getKnownUsers)
                    this.getKnownUsers.forEach((e) => {
                        if (e._id == user_id) {
                            name = e
                        }
                    })
                }
                return name
            },
            priorityChange (color, text) {
                this.priority_color = color
                this.priority_text = text
                this.show_menu = !this.show_menu
                this.$socket.emit('IN_Priority', {
                    task_id: this.task._id,
                    project_id: this.project_id,
                    priority: text,
                    author: JSON.stringify({name: this.getUserData.name, id: this.getUserData._id})
                })
            },  
            openPriorityMenu () {
                this.show_menu = !this.show_menu
            },
            tabTask: function (task_id) {
                EventEmitter.$emit('Note_Size', task_id)
                // Проверяем vuex getAssigns есть ли там данные 
                let send_data = true
                this.getAssigns.forEach(e => {
                    if(e.task_id == this.$route.params.task_id) {
                        
                        setTimeout(() => {
                            send_data = false
                            if (e.user_id) {
                                let data = {
                                    assign: e,
                                    update: false
                                }
                                EventEmitter.$emit('AssignFind', data)
                            }else{
                                e.user_id = ''
                                let data = {
                                    assign: e,
                                    update: false
                                }
                                EventEmitter.$emit('AssignFind', data)
                            }
                        }, 100);
                        // EventEmitter.$emit('AssignUser', data)
                    }
                })
                // Если нет данных то мы отправляем данные в бек
                if(send_data){
                    // this.$socket.emit('IN_AssignFind', {
                    //     task_id: task_id
                    // })
                }
                // const assign = this.getAssigns.find((e) => e.task_id == task_id)
                // if(assign){
                //     console.log(assign)
                // }else{
                //     console.log(this.$store.state.getAssigns)
                //     // this.$on('AssignFind', (data) => {
                //     //     console.log(data)
                //     // })
                // }
            },
            linkToTask(task_id) {
                setTimeout(() => {
                    if (document.querySelector('.right_col_sidebar')) {
                        document.querySelector('.right_col_sidebar').classList.add('run_anime')
                    }
                }, 10)
                // localStorage.setItem('project_id', this.project_id)
                if (this.chat_id) {
                    return `/chats/${this.chat_id}/project/${this.project_id}/task/${task_id}`;
                } else {
                    if (this.$route.matched[0].name == 'Inbox') {
                        return `/inbox/${this.task.project_id}/task/${task_id}`;
                    } else {
                        return `/project/${this.task.project_id}/task/${task_id}`;
                    }
                    // return `/project/${this.$route.params.project_id}/task/${task_id}`;
                }
            },
            getNextDue(current, repeat) {
                switch (repeat) {
                case 'daily':
                    return current.clone().add(1, 'days');

                case 'every_weekday': {
                    const next = current.clone().add(1, 'days');
                    const day = next.day(); // 0 = Sunday, 6 = Saturday

                    if (day === 6) return next.add(2, 'days'); // skip Saturday → Monday
                    if (day === 0) return next.add(1, 'days'); // skip Sunday → Monday
                    return next;
                }

                case 'weekly':
                    return current.clone().add(1, 'weeks');

                case 'every_two_weeks':
                    return current.clone().add(2, 'weeks');

                case 'monthly':
                    return current.clone().add(1, 'months');

                case 'every_two_months':
                    return current.clone().add(2, 'months');

                case 'yearly':
                    return current.clone().add(1, 'years');

                default:
                    return current.clone(); // fallback
                }
            },
            change_complete() {

                const recurTask = this.get_recur.find((e) => e.task_id == this.task._id)

                if (recurTask) {

                    // const due = moment(Number(recurTask.start_date))
                    // const nextDue = this.getNextDue(due, recurTask.repeat)

                    this.$socket.emit('IN_CompletedRecurTask', {
                        list_id: this.task.project_id,
                        task_id: this.task._id,
                        recur_id: recurTask._id,
                        completed: !recurTask.completed
                    })
                    return

                    // console.log(recurTask.occurrences_count, recurTask.ends_after)
                    // if (recurTask.ends == 'after') {
                    //     if (recurTask.ends_after > 1) {
                    //         if (recurTask.occurrences_count <= recurTask.ends_after) {
                    //             if (recurTask.enabled) {
                    //                 this.$socket.emit('IN_CompletedRecurTask', {
                    //                     list_id: this.task.project_id,
                    //                     task_id: this.task._id,
                    //                     recur_id: recurTask._id,
                    //                     completed: !recurTask.completed
                    //                 })
                    //                 return
                    //             }
                    //         }
                    //     }
                    // }

                    // if (recurTask.ends == 'on_date' && !nextDue.isAfter(moment(Number(recurTask.ends_on)))) {
                    //     if (recurTask.enabled) {
                    //         this.$socket.emit('IN_CompletedRecurTask', {
                    //             list_id: this.task.project_id,
                    //             task_id: this.task._id,
                    //             recur_id: recurTask._id,
                    //             completed: !recurTask.completed
                    //         })
                    //         return
                    //     }
                    // }

                    // this.change_enabled_recur({
                    //     _id: recurTask._id,
                    //     enabled: false
                    // })

                }

                setTimeout(() => {
                    this.show_subtask = false
                    localStorage.setItem(this.task._id, this.show_subtask)
                }, 500)

                if (this.task.done) {
                    this.task_class = 'tasks_row_completed'
                } else {
                    this.task_class = ''
                }
                
                this.$emit("change_complete", {
                    complete: this.task.done,
                    task_id: this.task._id,
                    list_id: this.task.project_id
                })

            },
            deleteTask(task) {
                let body_to_del = {
                    project_id: this.project_id,
                    task_id: task._id,
                    task_file_size: task.file_size,
                };
                this.$emit("delete_task", body_to_del)
                // console.log(this.$route)
                if (this.$route.name == 'InboxTaskBody') {
                    this.$router.push(`/inbox/${this.$route.params.project_id}`).catch(() => true)
                } else {
                    if (this.$route.params.task_id && this.$route.params.task_id == task._id) {
                        this.$router.push(`/project/${this.project_id}`)
                    }
                }
                // const comments = this.getComments[task._id]
                // comments.forEach((e) => {
                //     e.files.forEach((f) => {
                //         this.setUserFileSize_minus(+f.size)
                //     })
                // })
                this.socket_delete_task(body_to_del);
                setTimeout(() => {
                    const aws = new File()
                    aws.removeFolder('Lists' + '/' + this.project_id + '/' + task._id + '/')
                }, 1000)
            },
            assignDateTask(date) {

                if (isNaN(date)) {
                    date = new Date(date).getTime()
                }

                if (isNaN(this.assign_date)) {
                    this.assign_date = new Date(this.assign_date).getTime()
                }

                if (this.assign_date) {
                    if (this.assignDate(this.assign_date) == 'Today' || this.assignDate(this.assign_date) == 'Yesterday') {
                        return `<p style="color: #FF8686">${this.enumAssign[this.assignDate(this.assign_date)] ? this.enumAssign[this.assignDate(this.assign_date)] : this.assignDate(this.assign_date)}</p>`
                    } else {
                        if (this.assign_date > Date.now()) {
                            return `<p style="color: #489CDC">${this.enumAssign[this.assignDate(this.assign_date)] ? this.enumAssign[this.assignDate(this.assign_date)] : this.assignDate(this.assign_date)}</p>`
                        } else {
                            return `<p style="color: #FF8686">${this.enumAssign[this.assignDate(this.assign_date)] ? this.enumAssign[this.assignDate(this.assign_date)] : this.assignDate(this.assign_date)}</p>`
                        }
                    }
                } else {
                    if (this.assignDate(date) == 'Today' || this.assignDate(date) == 'Yesterday') {
                        return `<p style="color: #FF8686">${this.enumAssign[this.assignDate(date)] ? this.enumAssign[this.assignDate(date)] : this.assignDate(date)}</p>`
                    } else {
                        if (date > Date.now()) {
                            return `<p style="color: #489CDC">${this.enumAssign[this.assignDate(date)] ? this.enumAssign[this.assignDate(date)] : this.assignDate(date)}</p>`
                        } else {
                            return `<p style="color: #FF8686">${this.enumAssign[this.assignDate(date)] ? this.enumAssign[this.assignDate(date)] : this.assignDate(date)}</p>`
                        }
                    }
                }
            }
        },
        computed: {
            ...mapGetters([
                "get_flag_for_unreaded",
                "get_unreaded_messages_in_tasks",
                "get_active_task_window",
                "getTasks",
                "getProjects",
                "getAssigns",
                "getComments",
                "getKnownUsers",
                "getUserData",
                "getSubTask",
                "get_flag_for_tasks",
                "get_flag_for_add_task",
                "getRenderUserData",
                "getRenderKnownUsers",
                "getPlan",
                "getListsMentions",
                "get_recur"
            ]),
            getTaskDone() {
                return this.done
            },
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                }
            }
        },
        watch: {
            get_unreaded_messages_in_tasks(newVal) {
                this.unread_msg = newVal
            },
            get_flag_for_unreaded() {
                this.unread_msg = []
                this.unread_msg = this.get_unreaded_messages_in_tasks
            },
            get_flag_for_tasks(e) {

                this.assign_name = ''
                this.assign_date = ''
                this.check_assign = false
                this.priority_text = ''

                this.show_subtask = localStorage.getItem(this.task._id) == 'true' ? true : false

                if (this.task.done) {
                    this.task_class = 'tasks_row_completed'
                } else {
                    this.task_class = ''
                }

                this.priority_text = this.task.priority ? this.task.priority : 'Normal'

                if (this.priority_text == 'Normal') {
                    this.priority_color = '#f3f3f3'
                } else if (this.priority_text == 'Medium') {
                    this.priority_color = '#F4F915'
                } else if (this.priority_text == 'High') {
                    this.priority_color = '#F12E2E'
                }

                if (this.getSubTask) {
                    let sub = []
                    this.getSubTask.forEach((e, i) => {
                        if (e.parent == this.task._id) {
                            sub.push(e)
                        }
                    })
                    let filtered = sub.filter(function (el) {
                        return el != null
                    })
                    this.subtasks = []
                    this.subtasks = filtered
                    this.subtasks.sort( function (a, b) {
                        return a.order - b.order
                    })
                }

            },
            getTaskDone(e) {
                this.task_class = e ? "tasks_row_completed" : ""
            },
            getRenderKnownUsers() {
                setTimeout(() => {
                    if (this.getUserData._id == this.assign_name._id) {
                        this.assign_name = this.getUserData
                    } else {
                        this.getKnownUsers.forEach((e) => {
                            if(e._id == this.assign_name._id) {
                                this.assign_name = e
                            }
                        })
                    }
                    if (document.querySelector('.avatar_img')) {
                        document.querySelectorAll('.avatar_img').forEach((e) => {
                            e.parentNode.classList.add("avatar_img_span")
                        })
                    }
                }, 500)
            },
            getRenderUserData() {

                setTimeout(() => {
                    if (document.querySelector('.avatar_img')) {
                        document.querySelectorAll('.avatar_img').forEach((e) => {
                            e.parentNode.classList.add("avatar_img_span")
                        })
                    }
                }, 500)

                let expand_subtask = this.default_expand_subtask == 'Enabled' ? true : false
                if (expand_subtask != this.getUserData.expand_subtask) {
                    if (this.getUserData.expand_subtask == true) {
                        this.show_subtask = true
                        this.default_expand_subtask = 'Enabled'
                        this.getProjects.forEach((project) => {
                            if (this.getTasks[project._id]) {
                                this.getTasks[project._id].forEach((task) => {
                                    localStorage.setItem(task._id, true)
                                })
                            }
                        })
                    }
                    if (this.getUserData.expand_subtask == false) {
                        this.show_subtask = false
                        this.default_expand_subtask = 'Disabled'
                        this.getProjects.forEach((project) => {
                            if (this.getTasks[project._id]) {
                                this.getTasks[project._id].forEach((task) => {
                                    localStorage.setItem(task._id, false)
                                })
                            }
                        })
                    }
                }
            },
            $route(to) {

                this.transition_name = ''

                setTimeout(() => {
                    this.transition_name = 'slide-fade'
                }, 1000)

                setTimeout(() => {
                    if (document.getElementById('add_comment_block_list')) {
                        document.getElementById('add_comment_block_list').focus()
                        document.querySelector('#right_sidebar__bottom').click()
                    }
                }, 100)

                if (document.querySelector('.avatar_img')) {
                    document.querySelectorAll('.avatar_img').forEach((e) => {
                        e.parentNode.classList.add("avatar_img_span")
                    })
                }

                this.done = this.task.done

                this.subtasks = []

                if (this.getSubTask) {
                    if (this.subtasks.length == 0) {

                        let sub = []

                        this.getSubTask.forEach((e, i) => {
                            if (e.parent == this.task._id) {
                                sub.push(e)
                            }
                        })

                        let filtered = sub.filter(function (el) {
                            return el != null
                        })

                        this.subtasks = filtered
                        this.subtasks.sort( function (a, b) {
                            return a.order - b.order
                        })

                    }
                }

                this.show_subtask = localStorage.getItem(this.task._id) == 'true' ? true : false

                this.priority_text = this.task.priority ? this.task.priority : 'Normal'

                if (this.priority_text == 'Normal') {
                    this.priority_color = '#f3f3f3'
                } else if (this.priority_text == 'Medium') {
                    this.priority_color = '#F4F915'
                } else if (this.priority_text == 'High') {
                    this.priority_color = '#F12E2E'
                }

            },
            task(newVal) {
                this.editingText = newVal.name
            },
            '$store.state.tasks.recur': {
                async handler(v) {
                    setTimeout(() => {
                       this.recur = v.find(e => e.task_id == this.task._id)
                    }, 1000)
                },
                deep: true
            },
        },
        components: {
            RenameElement,
            SubTask,
            draggable
        }
    }

</script>
